import { useFormContext } from "react-hook-form";
import type { UseMutationOptions } from "react-query";
import { useMutation, useQueryClient } from "react-query";
import { workflowsApi } from "@/react/api";

const deleteAction = (workflowId: string, id: string) =>
  workflowsApi.deleteAction({
    workflowId,
    id,
  });

export const useDeleteAction = (
  options: UseMutationOptions<undefined, Error, string> = {},
) => {
  const { watch } = useFormContext();
  const workflowId = watch("id") as string;
  const queryClient = useQueryClient();

  return useMutation((id: string) => deleteAction(workflowId, id), {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["workflows", workflowId]);
      void options.onSuccess?.(data, variables, context);
    },
  });
};
